export default __webpack_public_path__ + "static/media/transparent.86aff87a.png";